import axios from "axios";
export default async function BuscaAPI(url) {
    //const response = await axios.get('http://localhost:21165/api/produtos');
    const response = await axios.get(url);
    return response.data;
}